import { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { NotaFiscalGlobalListItem } from './types';

export type NotaFiscalAcao =
  | 'mostrar'
  | 'solicitar'
  | 'upload'
  | 'aprovar'
  | 'reprovar'
  | 'pagamento'
  | 'editar'
  | 'excluir';

/** Itens visíveis no menu, na ordem da listagem. Só entra o que o status permite. */
export function acoesDisponiveis(row: NotaFiscalGlobalListItem): NotaFiscalAcao[] {
  const status = row.status;
  const itens: NotaFiscalAcao[] = ['mostrar'];
  if (status === 'NSO' || status === 'SOL' || status === 'REP') itens.push('solicitar');
  if (status === 'SOL') itens.push('upload');
  if (status === 'PAP') itens.push('aprovar', 'reprovar');
  if ((status === 'APR' || status === 'CON') && !row.nfPaga) itens.push('pagamento');
  if (status === 'NSO') itens.push('editar');
  // Sempre visível, como o DoDelete da WW. existeNotaEmpresa vem de
  // checkNotaFiscalEmpresaNotaFiscalColaboradorEmitida: só é verdadeiro
  // quando alguma NF da empresa vinculada está emitida (EMI).
  itens.push('excluir');
  return itens;
}

const ROTULO: Record<NotaFiscalAcao, string> = {
  mostrar: 'mostrar',
  solicitar: 'solicitar',
  upload: 'upload',
  aprovar: 'aprovar',
  reprovar: 'reprovar',
  pagamento: 'informarPagamento',
  editar: 'editar',
  excluir: 'excluir',
};

export interface NotaFiscalColaboradorAcoesMenuProps {
  row: NotaFiscalGlobalListItem;
  onAcao: (acao: NotaFiscalAcao) => void;
}

export function NotaFiscalColaboradorAcoesMenu({
  row,
  onAcao,
}: NotaFiscalColaboradorAcoesMenuProps): JSX.Element {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const close = (): void => setAnchor(null);

  function run(acao: NotaFiscalAcao): void {
    close();
    onAcao(acao);
  }

  return (
    <>
      <Button
        size="small"
        variant="text"
        aria-haspopup="menu"
        aria-expanded={anchor ? true : undefined}
        aria-label={t('features.colaboradores.notasFiscaisGlobal.actions.menuAria', {
          nome: row.colaboradorNome,
        })}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        {t('features.colaboradores.notasFiscaisGlobal.actions.menu')}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        {acoesDisponiveis(row).map((acao) => (
          <MenuItem key={acao} onClick={() => run(acao)}>
            {t(`features.colaboradores.notasFiscaisGlobal.acoes.${ROTULO[acao]}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
